import { abbrNumberFilter, percentageSignFilter, simplePercentageFilter } from "app/filters/ngFilters";

export const CONVERSION_RATE_TRANSLATION_KEYS = {
    sectionSubtitle: "industryoverview.conversionrate.section.subtitle",
    sectionSubtitleComparison: "industryoverview.conversionrate.section.subtitle.comparison",
    sectionSubtitleComparisonPop: "industryoverview.conversionrate.section.subtitle.comparison.pop",
    totalConvertedVisitsTitle: "industryoverview.conversionrate.totalconvertedvisits.title",
    totalConvertedVisitsTooltip: "industryoverview.conversionrate.totalconvertedvisits.tooltip",
    avgConversionRateTitle: "industryoverview.conversionrate.avgconversionrate.title",
    avgConversionRateTooltip: "industryoverview.conversionrate.avgconversionrate.tooltip",
    changeText: "industryoverview.conversionrate.change.text",
    changeNA: "industryoverview.conversionrate.change.na",
    lockedTitle: "industryoverview.conversionrate.locked.title",
    lockedCta: "industryoverview.conversionrate.locked.cta",
    popChangeSuffixYoY: "industryoverview.conversionrate.pop.change.suffix.yoy",
    popChangeSuffixPoP: "industryoverview.conversionrate.pop.change.suffix.pop",
    topByVolumeTitle: "industryoverview.conversionrate.leaders.byvolume.title",
    topByVolumeTooltip: "industryoverview.conversionrate.leaders.byvolume.tooltip",
    topByRateTitle: "industryoverview.conversionrate.leaders.byrate.title",
    topByRateTooltip: "industryoverview.conversionrate.leaders.byrate.tooltip",
    leadersColRank: "industryoverview.conversionrate.leaders.column.rank",
    leadersColDomain: "industryoverview.conversionrate.leaders.column.domain",
    leadersColConvertedVisits: "industryoverview.conversionrate.leaders.column.convertedvisits",
    leadersColConversionRate: "industryoverview.conversionrate.leaders.column.conversionrate",
    leadersColChange: "industryoverview.conversionrate.leaders.column.change",
    leadersExploreAllCta: "industryoverview.conversionrate.leaders.exploreall.cta",
    comparisonCardTitle: "industryoverview.conversionrate.comparison.card.title",
    comparisonCardTooltip: "industryoverview.conversionrate.comparison.card.tooltip",
    comparisonColIndustry: "industryoverview.conversionrate.comparison.column.industry",
    comparisonColConvertedVisits: "industryoverview.conversionrate.comparison.column.convertedvisits",
    comparisonColChange: "industryoverview.conversionrate.comparison.column.change",
    comparisonColAvgRate: "industryoverview.conversionrate.comparison.column.avgrate",
    comparisonColYoYChange: "industryoverview.conversionrate.comparison.column.yoychange",
    comparisonColPopChange: "industryoverview.conversionrate.comparison.column.popchange",
    comparisonSeparator: "industryoverview.conversionrate.comparison.dateseparator",
} as const;

export const conversionRateFormatters = {
    // @ts-expect-error FIXME: Argument of type 'number' is not assignable to parameter of type 'boolean'
    convertedVisits: (value: number): string => abbrNumberFilter()(value, 0),
    avgConversionRate: (value: number): string => percentageSignFilter()(value, 1) as string,
    visitsChange: (change: number): string => {
        const result = simplePercentageFilter()(change, 1) as string;
        return result === "N/A" ? result : `${result}%`;
    },
    rateChange: (change: number): string => {
        const result = simplePercentageFilter()(change, 1) as string;
        return result === "N/A" ? result : `${result}pp`;
    },
};
